export const invoiceStatus = {
    ReadyForInvoicing: 0,
    Invoiced: 1,
}